import React from 'react';
import './WeatherPanel.css';

// This helper can be outside the component
const getWeatherIcon = (weather) => {
  switch (weather) {
    case 'sunny': return '☀️';
    case 'cloudy': return '☁️';
    case 'rainy': return '☂️'; // Changed to umbrella icon
    default: return '❓';
  }
};

const WeatherPanel = ({ emsViewMode, data }) => {
  // Determine the correct time series data based on the view mode
  const timeSeries = emsViewMode === 'ems-historical-comparison' ? (data?.actual?.time_series || []) : (data?.time_series || []);

  const weatherData = timeSeries
    .map(item => ({
      time: new Date(item.time).toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit', hour12: false }),
      temperature: item.temperature !== undefined ? Number(item.temperature).toFixed(1) : '–',
      solarRadiation: {
        value: item.solarRadiation !== undefined ? (Math.round(item.solarRadiation * 10) / 10).toFixed(1) : '–',
        isPositive: item.solarRadiation > 0
      },
      precipitation: {
        value: item.precipitation !== undefined ? Number(item.precipitation).toFixed(1) : '–',
        isPositive: item.precipitation > 0
      },
      weatherIcon: getWeatherIcon(item.weather)
    }));

  return (
    <div className="weather-panel">
      <div className="weather-table-container">
        <div className="weather-table">
          <div className="weather-row header-row">
            <div className="weather-cell header-cell">時刻</div>
            {weatherData.map((data, index) => (
              <div key={index} className="weather-cell time-cell">{data.time}</div>
            ))}
          </div>
          <div className="weather-row">
            <div className="weather-cell header-cell">天気</div>
            {weatherData.map((data, index) => (
              <div key={index} className="weather-cell icon-cell">{data.weatherIcon}</div>
            ))}
          </div>
          
          <div className="weather-row">
            <div className="weather-cell header-cell">気温[℃]</div>
            {weatherData.map((data, index) => (
              <div key={index} className="weather-cell temp-cell">{data.temperature}</div>
            ))}
          </div>
          
          <div className="weather-row">
            <div className="weather-cell header-cell">日射量[kW/m²]</div>
            {weatherData.map((data, index) => (
              <div key={index} className={`weather-cell solar-cell ${data.solarRadiation.isPositive ? 'value-positive' : ''}`}>
                {data.solarRadiation.value}
              </div>
            ))}
          </div>
          
          <div className="weather-row">
            <div className="weather-cell header-cell">降水量[mm]</div>
            {weatherData.map((data, index) => (
              <div key={index} className={`weather-cell precip-cell ${data.precipitation.isPositive ? 'value-positive' : ''}`}>
                {data.precipitation.value}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherPanel;